import { Button, Stack, Typography, Grid, styled } from "@mui/material";

export const CourseAssetsWrapper = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(3),
  background: theme.palette.mode === "dark" ? "rgba(0,0,0,0.1)" : theme.palette.grey[50],
  color: theme.palette.mode === "dark" ? theme.palette.text.primary : theme.palette.grey[600],
  gap: theme.spacing(2),
  borderRadius: "6px",
  border:
    theme.palette.mode === "dark"
      ? "1px solid " + theme.palette.grey[700]
      : "1px solid " + theme.custom.palette.blueGrey[100],
}));

export const Handout = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  flexBasis: "100%",

  color:
    theme.palette.mode === "dark" ? theme.custom.palette.blue[300] : theme.custom.palette.blue[500],

  ["& svg"]: {
    marginTop: "2px",
  },

  ["& a"]: {
    color:
      theme.palette.mode === "dark"
        ? theme.custom.palette.blue[300]
        : theme.custom.palette.blue[500],
  },
}));
